export const MAX_TEMPLATE_FILE_BYTES = 20 * 1024 * 1024;

export const templateFamilyKey = (template) => `${String(template?.name || '').trim().toLowerCase()}::${template?.template_type || 'estate_plan'}`;

export const templateLabel = (template) => `${template?.name || 'Untitled template'} v${template?.version || 1}`;

export const isTemplateActive = (template) => template?.status === 'active';

export const nextTemplateStatus = (template) => isTemplateActive(template) ? 'archived' : 'active';

export const sortTemplates = (templates = []) => [...templates].sort((left, right) => {
  const activeDifference = Number(isTemplateActive(right)) - Number(isTemplateActive(left));
  if (activeDifference !== 0) return activeDifference;
  const nameDifference = String(left.name || '').localeCompare(String(right.name || ''));
  if (nameDifference !== 0) return nameDifference;
  return Number(right.version || 0) - Number(left.version || 0);
});

export const activeTemplates = (templates = []) => sortTemplates(templates.filter(isTemplateActive));

export const nextTemplateVersion = (templates, template) => {
  const family = templateFamilyKey(template);
  const highestVersion = templates
    .filter((candidate) => templateFamilyKey(candidate) === family)
    .reduce((highest, candidate) => Math.max(highest, Number(candidate.version || 0)), 0);
  return highestVersion + 1;
};

export const validateTemplateFile = (file) => {
  if (!file) return 'Choose a DOCX file to upload.';
  if (!file.name?.toLowerCase().endsWith('.docx')) return 'Template uploads must use the .docx file type.';
  if (file.size > MAX_TEMPLATE_FILE_BYTES) return 'Template files must be 20 MB or smaller.';
  if (file.size === 0) return 'The selected DOCX file is empty.';
  return null;
};

export const isReadableDocxPackage = (zipEntries) => Boolean(
  zipEntries?.['[Content_Types].xml'] && zipEntries?.['word/document.xml']
);

export const buildTemplateInsert = ({ file, form, lawFirmId, userId, storagePath, version }) => ({
  law_firm_id: lawFirmId,
  name: form.name.trim(),
  description: form.description.trim() || null,
  template_type: form.template_type || 'estate_plan',
  version,
  status: form.active ? 'active' : 'archived',
  storage_bucket: 'document-templates',
  storage_path: storagePath,
  file_name: file.name,
  content_type: file.type || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  file_size: file.size,
  created_by: userId
});

export const historicalTemplateLabel = (template) => isTemplateActive(template)
  ? templateLabel(template)
  : `${templateLabel(template)} (Inactive)`;

export const deletionMessage = (template, generatedDocuments = []) => generatedDocuments.some(
  (document) => document.document_template_id === template?.id
)
  ? 'This template is referenced by generated drafts and is retained. Use Inactive instead of deletion.'
  : 'Templates are retained for this pilot. Use Inactive instead of deletion.';
